import { withStyles } from '@material-ui/core/styles'
import React, { useEffect } from 'react'
import styles from './styles'

import { useDispatch, useSelector } from 'react-redux'
import {
  ShareViewHeader,
  ShareView,
  EmbedView,
  ShareLinkCourse,
  EmbedViewCourse,
  IframeViewCourse,
  PdfCourse,
  ScormView,
} from './components'
import { useLocation } from 'react-router-dom'
import { getCourseByIdAction } from 'src/reducers/course/action'
const SharePopover = props => {
  const { classes } = props
  const location = useLocation()
  const coursePage = location.pathname.includes('course')

  const [view, setView] = React.useState(
    coursePage ? 'share-course' : 'share-collection',
  )
  const course = useSelector(state => state.course.course)

  useEffect(() => {
    if (coursePage) {
      dispatch(getCourseByIdAction(course.id, response => {}))
    }
  }, [course])

  const dispatch = useDispatch()
  const handleView = view => {
    setView(view)
  }

  const selectedCollection = useSelector(
    state => state.courseCollectionList.selectedCollection,
  )
  const collection = useSelector(state =>
    state.courseCollectionList.list.courseCollectionDtos.filter(
      collection => collection.id === selectedCollection,
    ),
  )
  const me = useSelector(state => state.authentication.me)

  const collectionComponents = [
    {
      component: (
        <ShareView
          entity={collection[0]}
          dispatch={dispatch}
          handleView={handleView}
        />
      ),
      onView: view == 'share-collection',
      mainPage: true,
    },
    {
      component: <EmbedView entity={collection[0]} handleView={handleView} />,
      onView: view == 'embed-collection',
      mainPage: true,
    },
  ]
  const courseComponents = [
    {
      component: <ShareLinkCourse handleView={handleView} />,
      onView: view == 'share-course',
      mainPage: true,
    },
    {
      component: <EmbedViewCourse handleView={handleView} />,
      onView: view == 'embed-course',
      mainPage: true,
    },
    {
      component: <IframeViewCourse handleView={handleView} />,
      onView: view == 'iframe-course',
      mainPage: true,
    },
    {
      component: <PdfCourse handleView={handleView} me={me} />,
      onView: view == 'pdf-course',
      mainPage: true,
    },
    {
      component: <ScormView handleView={handleView} me={me} />,
      onView: view == 'scorm-course',
      mainPage: true,
    },
  ]

  return (
    <div className={classes.content}>
      <div className={classes.content__components}>
        <ShareViewHeader view={view} handleView={handleView} />
        {coursePage
          ? courseComponents.map(
              (component, index) =>
                component.onView && (
                  <div key={index}>{component.component}</div>
                ),
            )
          : collectionComponents.map(
              (component, index) =>
                component.onView && (
                  <div key={index}>{component.component}</div>
                ),
            )}
      </div>
    </div>
  )
}

export default withStyles(styles)(SharePopover)
